   const defaultState = {
        status:"default",
        data: [],
        code: 500,
        message: "",
      };
      
      let response = {};
      const Typetatib_lib = (state = defaultState, action = {}) => {
        switch (action.type) {
          case "SUCCESS_TYPETATIB":
            response = {
              ...state,
              data: action.data ? action.data : {},
              code: action.code ? action.code : 500,
              status:"success",
              message: action.message ? action.message : "",
            };
      
            break;
            case "LOADING_TYPETATIB":
            response = {
              ...state,
              status:"loading",
            };
            break;
          case "ERROR_TYPETATIB":
            response = {
              ...state,
              status:"error",
              message: action.message ? action.message : "",
              code: action.code ? action.code : 500,
            };
            break;
          default:
            return {
              ...state, 
              loadingPage: false,
              loadingSend: false
            };
        }
      
        return response;
      };
      
      export default Typetatib_lib
      